<template>
  <div class="row">
    <div
      v-for="(accommodation, idx) in accommodations"
      :key="idx"
      class="col-sm-6 mb-4"
    >
      <BCard class="accommodation">
        <BCardText>
          <CertificationFormGroup :name="`accommodations.$each.${idx}.generalError`">
            <template slot-scope="{validator}">
              <InputHiddenControl id="'accommodations-general-' + idx"/>
            </template>
          </CertificationFormGroup>

          <CertificationFormGroup
            :name="`accommodations.$each.${idx}.name`"
            :can-moderate="false"
          >
            <template slot-scope="{ validator }">
              <LocationTypeAheadControl
                id="accommodation.name"
                v-model="accommodation.name"
                label="Nazwa"
                :disabled="disabled"
                @input="touch(validator)"
                @update:item="setAccommodationData(idx, $event)"
              />
            </template>
          </CertificationFormGroup>

          <CertificationFormGroup :name="`accommodations.$each.${idx}.city`">
            <template slot-scope="{ validator }">
              <InputControl
                id="accommodation.city"
                v-model="accommodation.city"
                label="Miejscowość"
                :disabled="accommodation.id > 0 || disabled"
                @input="touch(validator)"
              />
            </template>
          </CertificationFormGroup>

          <CertificationFormGroup
            :name="`accommodations.$each.${idx}.typeStars`"
          >
            <StarsControl
              id="accommodation.typeStars"
              v-model="accommodation.typeStars"
              :disabled="disabled"
              label="Liczba gwiazdek"
            />
          </CertificationFormGroup>
        </BCardText>
        <Btn
          v-if="accommodations.length > 1 && !disabled"
          variant="outline-danger"
          size="sm"
          icon="map-marker-minus"
          @click="removeAccommodation(idx)"
        >
          Usuń
        </Btn>
      </BCard>
    </div>
    <div v-if="!disabled" class="col-sm-6">
      <Btn
        variant="outline-primary"
        icon="map-marker-plus"
        @click="addAccommodation"
      >
        Dodaj hotel
      </Btn>
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import StarsControl from "@/components/Controls/StarsControl";
import InputControl from "@/components/Controls/InputControl";
import LocationTypeAheadControl from "@/components/Controls/LocationTypeAheadControl";
import LocationModel from "@/model/Location";
import InputHiddenControl from '@/components/Controls/InputHiddenControl';
export default {
  name: "CertificationFormAccommodations",
  components: {
    StarsControl,
    InputControl,
    LocationTypeAheadControl,
    InputHiddenControl
  },
  extends: BaseFormControl,
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      accommodations: this.value,
      accommodationUrl: `${process.env.VUE_APP_XHR_ROOT}certification/location/?query=%query`
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      this.accommodations = newValue;
    }
  },
  methods: {
    setAccommodationData(idx, data) {
      if (data && data.id) {
        this.$set(this.accommodations[idx], "id", data.id);
        this.$set(this.accommodations[idx], "city", data.city);
        this.$set(this.accommodations[idx], "typeStars", data.typeStars);
      } else if (!data.id) {
        this.$set(this.accommodations[idx], "id", -1);
      }
    },
    addAccommodation() {
      let accommodation = new LocationModel();

      this.accommodations.push(accommodation);
    },
    removeAccommodation(idx) {
      // this.accommodations =
      this.accommodations.splice(idx, 1);
    }
  }
};
</script>
